import { createRoute } from '@tanstack/react-router';
import { Route as parent } from './site.tsx';
export const Route = createRoute({ getParentRoute: () => parent, path: 'checks' }).lazy(() =>
  import('./checks.tsx').then((module) => module.Route),
);
